import React from 'react'
import SearchIcon from 'assets/images/svg/search_orange.svg'

import {useTranslation} from "react-i18next";
import {useQuery} from "react-query";
import {DownloadCenterService} from "pages/download-center/download-center.service";
import {Spinner} from "react-bootstrap";
import ErrorMessage from "components/error/error";
import Info from "components/info";
import DownloadAppSection from "pages/download-center/components/download-app-section";
import { useIP } from 'hooks/use-products';

const DownloadCenterNew = () => {
    const { t } = useTranslation("download-center");
    const [query, setQuery] = React.useState("");
    let ip = useIP();

    const {
        data: apps = [],
        isLoading,
        isError,
        isFetching,
        isSuccess,
    } = useQuery(["download-apps", query, t], () => {
        if (query.trim())
            return DownloadCenterService.getFilteredApps(query).then(
                ({ response }) => response?.items ?? []
            );
        return DownloadCenterService.getAllApps().then(({ response }) => response);
    });

    return (
        <div className='downloadCenterNew'>
            <div className='downloadCenter-header'>
                <div className='info'>
                    <h1>{t('welcome-to-our-products')}</h1>
                    <p>{t('browse-our-products')}</p>
                </div>
                <div className='div-search'>
                    <input type="text" placeholder={t('search')} onChange={e => setQuery(e.target.value)} />
                    <img className='searchIcon' src={SearchIcon} alt="SearchIcon" />
                </div>
            </div>

            <div className='downloadCenter-info'>
                <h1>{t('you-own-shop')}</h1>
                <p>{t('we-offer-best-solution')}</p>
            </div>

            <div className='all-downloadCenter'>
                    {(isLoading || isFetching) && (
                        <div className="my-center">
                            <Spinner animation="grow" variant="primary" />
                        </div>
                    )}
                    {isError && <ErrorMessage />}
                    {isSuccess &&
                        (!apps?.length ?
                                <Info title={query ? t('emptySearch') : t('noApps')} /> :
                                apps?.map((app,index) => <DownloadAppSection key={app.id} app={app} index={index} ip={ip} />)
                        )}



            </div>

        </div>
    )
}

export default DownloadCenterNew